import React, {useState}  from 'react';
import {
  Card, Row, Col, 
  CardBody,CardHeader, CardTitle, 
  Modal, ModalBody,
 } from "reactstrap";
import { Spinner } from 'components/Icons/Spinner';
import { Link } from 'react-router-dom';
import { CourseEnrollSubject } from './CourseEnrollSubject';
import { CourseSetupSubject } from './CourseSetupSubject';
import { useSelector } from 'react-redux'
import { SubjectCard } from './SubjectCard';
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

var viewActions = require ('store/view.actions');
var courseApi = require ('../api');

var authLib =  require ('modules/auth/authLib');

var Icons = require ('Icons');

const SubjectListCard = ( { isLoading, enroleSubject, unEnroleSubject, scheduleClasss, unScheduleClass, enrollTeacher, unEnrollTeacher  } ) =>  {

  const [modalOpen, setModalOpen] = useState(false);
  const [setupSubject, setSetupSubject] = useState(false);
  const [subject, setSubject] = useState({});
  const [unenroled, setUnenroled] = useState({});
  const [loading, setLoading] = useState(false);
  

  const { course, token, subjects, userRoles } = useSelector(state => ({
    token: state.auth.session.jwt_token, 
    course: state.courses.course,
    subjects: state.courses.courseSubjects,
    userRoles: state.auth.session.userRoles
    
   }))



   const confirmDeleteSubject = (id) => { 

    confirmAlert({
      title: 'Atención',
      message: 'Confirma eliminar la materia '+subjects[id].long_name+'? Todos las configuracions y notas asociadas no podran ser recuperadas',
      buttons: [
        {
          label: 'Si, eliminar',
          onClick: () => {
            unEnroleSubject ( token, subjects[id].course_id, subjects[id].course_subject_id) ;
            
            viewActions.notification({message:'Se eliminó la materia '+subjects[id].long_name+' de este curso',
            title:'Materia eliminada',type:'warning'});

          }
        },
        {
          label: 'No'
        }
      ]
    });
    
  }

   const subjectSetup = (id) => { 
    setSubject(subjects[id]) ;
    setSetupSubject(true) ;
   }

   const addSubject = async () => {
    setLoading(true);
    let unen = await courseApi.getUnenroledSubjects ( token, course.course_id) ;

    setUnenroled( unen.map(c => { return { value: c.subject_id, label: c.long_name }} ) );
    setLoading(false);
    setModalOpen(!modalOpen) ;
   }

    return (
          <>
          <Modal toggle={() => setModalOpen(!modalOpen)} isOpen={modalOpen}  size="lg">
            <ModalBody >
                  <CourseEnrollSubject 
                    enroleSubject={enroleSubject}
                    unenroled={unenroled}
                   
                    closeMe={setModalOpen}
                  />
            </ModalBody>
          </Modal>
  
          <Modal toggle={() => setSetupSubject(!setupSubject)} isOpen={setupSubject}  size="lg">
            <ModalBody >
                  <CourseSetupSubject 
                    subj={subject}
                    unScheduleClass={unScheduleClass}
                    scheduleClasss={scheduleClasss}
                    enrollTeacher={enrollTeacher}
                    unEnrollTeacher={unEnrollTeacher}


                    closeMe={setModalOpen}
                  />
            </ModalBody>
          </Modal>
         

          {(subjects && !isLoading) ?
            <Card className="card-tasks" style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)'}}>
               <CardHeader>
                  <CardTitle tag="h4">Materias 
                        <div className="float-right">
                          {loading?
                          <Spinner />
                          :
                          <Link to="#"
                            onClick={() => { addSubject() }}
                          >
                            <i className={Icons.SUBJECT_ADD} />
                          </Link>
                          } 
                        </div>
                  </CardTitle>
                 <span>Hay {subjects.length} materias en este curso</span>
               </CardHeader>

               <CardBody>
                 {/* <div style={{ height: "500px", overflow: "auto", display: "block" } }> */}
                    <Row>
                        { subjects.map( ( subject, idx ) => { 
                          console.log( "AUDIT_EVALS_"+course.top_level)
                          return (
                              <Col md="6" key={idx}>
                                <SubjectCard 
                                  subject={subject} 
                                  openSetup={() => subjectSetup(idx)} 
                                  auditEvals={ authLib.authOK ( userRoles, "AUDIT_EVALS_"+course.top_level)} // AUDIT_EVALS
                                  deleteSubject={() => confirmDeleteSubject(idx)} 
                                  />
                                </Col>
                            ) 
                          }
                          ) 
                        }
                      
                    </Row>
                    
                  {/* </div> */}
                  </CardBody>
            </Card>                   
          :
          <Spinner size="XL" />
          }
        </>
  
        );
        }

export { SubjectListCard } ;
